<template>
  <div class="box-detail">
    <div class="box-left">
      <div class="box-left-header">
        <div
          @click="$router.push({ path: '/serviceResources' })"
          class="goBack c-position-static c-m-0"
        >
          <i class="el-icon-arrow-left"></i>
          <span>服务资源</span>
        </div>
      </div>
      <div class="box-left-content">
        <el-form
          ref="formData"
          :model="formData"
          :rules="rules"
          label-width="80px"
          label-position="right"
        >
          <el-form-item label="资源名称" prop="name">
            <el-input v-model="formData.name"></el-input>
          </el-form-item>
          <el-form-item
            label="资源编号"
            prop="order"
            :rules="{
              required: false
            }"
          >
            <el-input v-model="formData.order"></el-input>
          </el-form-item>
          <el-form-item label="资源描述" prop="description">
            <el-input type="textarea" v-model="formData.description"></el-input>
          </el-form-item>
          <el-form-item label="资源类型" prop="resourceType">
            <el-select v-model="formData.resourceType" clearable @change="resourceTypeChange">
              <el-option
                v-for="item in options.resourceType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="选择资源"
            prop="serviceCrewId"
            v-if="formData.resourceType == 'serviceCrew' || formData.resourceType == 'partner'"
          >
            <el-select
              v-model="formData.serviceCrewId"
              filterable
              remote
              :remote-method="getOrg"
              clearable
              @clear="getOrg"
              @change="getServiceType"
              placeholder="请先选择资源类型（支持名称搜索）"
            >
              <el-option
                v-for="item in options.org"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择资源" prop="relatedRecordId" v-else>
            <el-select
              v-model="formData.relatedRecordId"
              filterable
              remote
              :remote-method="getUser"
              clearable
              @clear="getUser"
              @change="$forceUpdate()"
              placeholder="请先选择资源类型（支持姓名搜索）"
            >
              <el-option
                v-for="item in options.user"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
                <span>{{ item.label }}</span>
                <span style="float: right; color: #c3C6CD; font-size: 13px">
                  {{ formatRoles(item.roleIds) }}
                </span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="tenantId != '4551453470943235290'"
            label="资源角色"
            prop="resourceRoles"
          >
            <el-select v-model="formData.resourceRoles" multiple clearable>
              <el-option
                v-for="item in options.resourceRoles"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <template
            v-if="
              tenantId == '1340835581184723420'
                ? formData.resourceRoles && formData.resourceRoles.indexOf('1') != -1
                  ? dataAuth > 3 ||
                    dataAuth == 0 ||
                    dataAuthId == '9144282109161981269' ||
                    dataAuthId == '7528632979004829751'
                    ? true
                    : false
                  : false
                : false
            "
          >
            <el-form-item
              label="资源等级"
              prop="resourceLevel"
              :rules="{
                required:
                  formData.resourceType == 'technician' &&
                  formData.resourceRoles.indexOf('1') != -1,
                trigger: 'change',
                message: '请选择资源等级'
              }"
            >
              <el-select v-model="formData.resourceLevel" clearable @change="resourceLevelChange">
                <el-option
                  v-for="item in options.resourceLevel"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <template
              v-if="
                formData.resourceLevel &&
                  (tenantId == '1340835581184723420'
                    ? formData.resourceRoles && formData.resourceRoles.indexOf('1') != -1
                      ? dataAuth > 3 ||
                        dataAuth == 0 ||
                        dataAuthId == '9144282109161981269' ||
                        dataAuthId == '7528632979004829751'
                        ? true
                        : false
                      : false
                    : true)
              "
            >
              <el-form-item
                v-for="(param, j) in formData.parameter"
                :key="j + '1'"
                :label="param.keyName"
                :rules="{
                  required: true
                }"
              >
                <el-input-number
                  v-model="param.value"
                  :min="0"
                  :precision="0"
                  :controls="false"
                ></el-input-number>
              </el-form-item>
            </template>
          </template>
          <el-form-item label="工作状态" prop="workType" v-if="tenantId == '1340835581184723420'">
            <el-select v-model="formData.workType" clearable>
              <el-option
                v-for="item in options.workState"
                :key="item.value"
                :label="item.label"
                :value="Number(item.value)"
              ></el-option>
            </el-select>
          </el-form-item>
          <template>
            <el-form-item
              label="服务类型"
              prop="serviceType"
              v-if="formData.resourceType == 'partner'"
              :rules="{
                required: true,
                trigger: 'change',
                message: '请选择服务类型'
              }"
            >
              <el-select v-model="formData.serviceType" multiple disabled>
                <el-option
                  v-for="item in options.serviceType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="服务类型"
              prop="serviceType"
              v-else
              :rules="{
                required: true,
                trigger: 'change',
                message: '请选择服务类型'
              }"
            >
              <el-select v-model="formData.serviceType" multiple placeholder="请选择服务类型">
                <el-option
                  v-for="item in options.serviceType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item label="资源位置">
            <el-input
              type="textarea"
              v-model="formData.lastKnownLocation"
              :disabled="
                formData.resourceType != 'serviceCrew' && formData.resourceType != 'partner'
              "
              @change="getGeocode"
            ></el-input>
          </el-form-item>
          <el-form-item label="经度">
            <el-input v-model="formData.gpsPoint.longitude" disabled></el-input>
          </el-form-item>
          <el-form-item label="纬度">
            <el-input v-model="formData.gpsPoint.latitude" disabled></el-input>
          </el-form-item>
          <el-form-item label="位置更新时间">
            <el-input v-model="formData.lastKnownLocationDate" disabled></el-input>
          </el-form-item>
          <el-form-item v-for="(extField, idx) in extFields" :key="idx" :label="extField.nameDisp">
            <template
              v-if="
                extField.type == 'text' || extField.type == 'textarea' || extField.type == 'number'
              "
            >
              <el-input v-model="formData.exts[extField.name]" :type="extField.type"></el-input>
            </template>
            <template v-if="extField.type == 'radio'">
              <el-radio-group v-model="formData.exts[extField.name]">
                <el-radio
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-if="extField.type == 'checkbox'" @change="$forceUpdate()">
              <el-checkbox-group v-model="formData.exts[extField.name]" @change="$forceUpdate()">
                <el-checkbox
                  v-for="item in options[extField.valueOption]"
                  :label="item.value"
                  :key="item.value"
                >
                  {{ item.label }}
                </el-checkbox>
              </el-checkbox-group>
            </template>
            <template v-if="extField.type == 'select'">
              <el-select v-model="formData.exts[extField.name]" placeholder="请选择" clearable>
                <el-option
                  v-for="item in options[extField.valueOption]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="extField.type == 'cascade'">
              <el-cascader
                clearable
                v-model="formData.exts[extField.name]"
                :options="options[extField.valueOption]"
                :props="{ checkStrictly: true, label: 'name' }"
              ></el-cascader>
            </template>
            <template v-if="extField.type == 'time'">
              <el-time-select
                v-model="formData.exts[extField.name]"
                placeholder="选择时间"
              ></el-time-select>
            </template>
            <template v-if="extField.type == 'date' || extField.type == 'datetime'">
              <el-date-picker
                v-model="formData.exts[extField.name]"
                :type="extField.type"
                placeholder="选择日期"
              ></el-date-picker>
            </template>
            <template v-if="extField.type == 'switch'">
              <el-switch
                v-model="formData.exts[extField.name]"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-value="1"
                inactive-value="0"
              ></el-switch>
            </template>
            <template v-if="extField.type == 'rate'">
              <el-rate v-model="formData.exts[extField.name]" @change="$forceUpdate()"></el-rate>
            </template>
          </el-form-item>
        </el-form>
      </div>
      <div class="box-left-footer">
        <el-button type="primary" @click="doSave">提交</el-button>
        <el-button plain @click="getData">取消</el-button>
      </div>
    </div>
    <div class="box-center">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="动态" name="log">
          <div class="box-center-tool">
            <div>
              <el-date-picker
                v-model="log.searchDate"
                type="datetimerange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
                value-format="yyyy-MM-dd HH:mm:ss"
                clearable
                @change="getLog"
                class="search-date"
              ></el-date-picker>
            </div>
            <div>
              <el-input
                placeholder="请输入标题/内容"
                v-model="log.searchValue"
                class="search-input"
                clearable
                @clear="getLog"
                @keyup.enter.native="getLog"
              >
                <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
              </el-input>
            </div>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
              <div class="activity-card-header">
                <span class="c-font-500">
                  <i class="el-icon-monitor c-w-30"></i>
                  {{ log.title }}
                </span>
                <span>{{ log.createTime }}</span>
              </div>
              <div class="activity-card-content">{{ log.content }}</div>
              <div class="activity-card-footer">
                <span>操作人：{{ log.updateUserName }}</span>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="笔记" name="notes">
          <div class="box-center-tool">
            <div></div>
            <el-button
              type="primary"
              size="mini"
              @click="
                vqeditor.content = ``;
                openNote = true;
              "
            >
              创建笔记
            </el-button>
          </div>
          <div class="box-center-content">
            <div class="activity-card" v-for="(note, i) in noteData" :key="i">
              <div class="activity-card-header">
                <span>
                  <i class="el-icon-edit-outline c-w-30"></i>
                  笔记
                </span>
                <span>{{ note.createTime }}</span>
              </div>
              <div
                class="activity-card-content-node"
                v-html="note.content"
                @click="noteMdShow(note)"
                v-if="!note.openNote"
              ></div>
              <c-editor
                v-else
                class="c-m-15"
                :formData="note"
                :value="'content'"
                ref="editor"
              ></c-editor>
              <div class="activity-card-footer">
                <span>操作人：{{ note.createUserName }}</span>
              </div>
            </div>
          </div>
          <!-- markdown编辑器 -->
          <el-dialog title="笔记" :visible.sync="openNote">
            <c-editor :formData="vqeditor" :value="'content'" ref="editor"></c-editor>
            <div slot="footer">
              <el-button type="primary" @click="saveNote">确 认</el-button>
              <el-button
                @click="
                  openNote = false;
                  vqeditor.content = '';
                "
              >
                取 消
              </el-button>
            </div>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="属性变更记录" name="history">
          <div
            class="box-center-content"
            v-infinite-scroll="getHistory"
            :infinite-scroll-immediate="true"
          >
            <c-modify
              :historyFpi="historyFpi"
              :fields="extFields"
              :fieldsObj="fieldsObj"
              :options="options"
              ref="modify"
            ></c-modify>
          </div>
        </el-tab-pane>
        <el-tab-pane
          label="业务跟踪"
          name="bizStackTraceSA"
          v-if="osg.has('ServiceResource,exception')"
        >
          <bizStackTrace :params="{ sid: id }" v-if="id"></bizStackTrace>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box-right" :class="collapse ? 'box-collapse' : ''">
      <div class="box-right-header">
        <i class="el-icon-d-arrow-left" @click="collapse = false" v-if="collapse"></i>
        <i class="el-icon-d-arrow-right" @click="collapse = true" v-else></i>
      </div>
      <div class="box-right-content" v-show="!collapse">
        <el-collapse :value="formData.resourceType">
          <el-collapse-item
            v-for="(type, index) of options.resourceType"
            :key="index"
            v-show="type.value == formData.resourceType"
            :name="type.value"
          >
            <template slot="title">
              <span>{{ type.label }}</span>
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of relatedData" :key="i">
                <div>
                  <i class="el-icon-user card-item-logo" style="color: #606266;"></i>
                </div>
                <div v-if="formData.resourceType == 'serviceCrew'">
                  <p>
                    <el-link href="/OrgUser" target="_blank">编号：{{ item.orgCode }}</el-link>
                  </p>
                  <p>
                    <span>名称：{{ item.orgName }}</span>
                  </p>
                </div>
                <div v-else-if="formData.resourceType == 'partner'">
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/Partner/' + item._id)"
                      target="_blank"
                    >
                      编号：{{ item.partnerNumber }}
                    </el-link>
                  </p>
                  <p>
                    <span>名称：{{ item.name }}</span>
                  </p>
                  <p>
                    <span>手机：</span>
                    <el-link :href="'tel:' + item.phone" target="_blank">
                      <i class="el-icon-phone-outline"></i>
                      {{ item.phone }}
                    </el-link>
                  </p>
                </div>
                <div v-else>
                  <p>
                    <el-link href="/OrgUser" target="_blank">编号：{{ item.code }}</el-link>
                  </p>
                  <p>
                    <span>姓名：{{ item.name }}</span>
                  </p>
                  <p>
                    <span>性别：{{ formatSex(item.sex) }}</span>
                  </p>
                  <p>
                    <span>角色：{{ formatRole(item.roleIds) }}</span>
                  </p>
                  <p>
                    <span>手机：</span>
                    <el-link :href="'tel:' + item.phone" target="_blank">
                      <i class="el-icon-phone-outline"></i>
                      {{ item.phone }}
                    </el-link>
                  </p>
                  <p>
                    <span>邮箱：</span>
                    <el-link :href="'mailto:' + item.email" target="_blank">
                      <i class="el-icon-message"></i>
                      {{ item.email }}
                    </el-link>
                  </p>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item name="relatedService">
            <template slot="title">
              <span>所属服务区域</span>
              <!-- <el-button type="text" icon="el-icon-plus" @click.stop="newServiceTerritory">
                添加服务区域
              </el-button> -->
            </template>
            <div class="card-group">
              <div class="card-item" v-for="(item, i) of serviceTerritory.relatedData" :key="i">
                <div>
                  <i class="el-icon-map-location card-item-logo" style="color: #606266;"></i>
                </div>
                <div>
                  <!-- {{ item.name }} -->
                  <p>
                    <el-link
                      @click="osg.open('', '', '_blank', '/ServiceTerritory/' + item._id)"
                      target="_blank"
                    >
                      服务区域名称：
                      {{ item.name }}
                    </el-link>
                  </p>
                  <p v-if="false">
                    <el-cascader
                      v-if="item.province"
                      size="mini"
                      :props="area.props"
                      :value="[item.province, item.city, item.district]"
                      class="area-view"
                      @change="$forceUpdate()"
                    ></el-cascader>
                  </p>
                  <p>
                    <span>街道：{{ item.street }}</span>
                  </p>
                  <p>
                    <span>详细地址：{{ item.address }}</span>
                  </p>
                  <p>
                    <span>服务类型：{{ formatServiceType(item.serviceType) }}</span>
                  </p>
                </div>
                <i
                  class="el-icon-close card-item-icon-remove"
                  @click="removeServiceTerritory(item)"
                ></i>
                <i class="el-icon-edit card-item-icon-edit" @click="editServiceTerritory(item)"></i>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <el-drawer
        custom-class="c-drawer"
        title="添加服务区域"
        :visible.sync="serviceTerritory.openRelate"
        direction="rtl"
        @close="initServiceTerritory"
      >
        <div class="el-drawer__content">
          <el-tabs v-model="serviceTerritory.activeName" type="card">
            <el-tab-pane label="选择已有服务区域" name="search">
              <p class="c-m-b-10 c-font-13">请输入服务区域名称进行搜索</p>
              <el-select
                v-model="serviceTerritory.searchObj"
                filterable
                remote
                reserve-keyword
                :remote-method="getServiceTerritoryData"
                @change="$forceUpdate()"
                clearable
                @clear="getServiceTerritoryData"
                class="c-w-1"
              >
                <el-option
                  v-for="item in serviceTerritory.data"
                  :key="item._id"
                  :label="item.label"
                  :value="item"
                >
                  <span class="c-fl">{{ item.name }}</span>
                  <span class="c-fr c-font-13"></span>
                </el-option>
              </el-select>
            </el-tab-pane>
            <el-tab-pane label="新建服务区域" name="create">
              <el-form
                :model="serviceTerritory.formData"
                :rules="rules"
                ref="serviceTerritoryFormData"
                label-width="120px"
                label-position="left"
                hide-required-asterisk:true
              >
                <el-form-item label="服务区域名称" prop="name">
                  <el-input
                    v-model="serviceTerritory.formData.name"
                    placeholder="请输入服务区域名称"
                    :rules="{
                      required: true,
                      trigger: 'blur',
                      message: '服务区域名称不能为空'
                    }"
                  ></el-input>
                </el-form-item>
                <el-form-item label="国家" prop="country">
                  <el-input
                    v-model="serviceTerritory.formData.country"
                    placeholder="请输入国家"
                  ></el-input>
                </el-form-item>
                <el-form-item label="省市区" prop="area">
                  <el-cascader
                    :options="area.options"
                    :props="area.props"
                    v-model="serviceTerritory.formData.area"
                    collapse-tags
                    clearable
                  ></el-cascader>
                </el-form-item>
                <el-form-item label="街道" prop="street">
                  <el-input
                    v-model="serviceTerritory.formData.street"
                    placeholder="请输入街道"
                  ></el-input>
                </el-form-item>
                <el-form-item label="邮编" prop="postalCode">
                  <el-input
                    v-model="serviceTerritory.formData.postalCode"
                    placeholder="请输入邮编"
                  ></el-input>
                </el-form-item>
                <el-form-item label="描述" prop="description">
                  <el-input
                    v-model="serviceTerritory.formData.description"
                    placeholder="请输入描述"
                  ></el-input>
                </el-form-item>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="el-drawer__footer" v-if="serviceTerritory.activeName == 'search'">
          <el-button
            type="primary"
            :disabled="!serviceTerritory.searchObj"
            @click="
              saveServiceTerritory('search');
              initServiceTerritory();
            "
          >
            保存
          </el-button>
          <el-button plain @click="initServiceTerritory()">取消</el-button>
        </div>
        <div class="el-drawer__footer" v-if="serviceTerritory.activeName == 'create'">
          <el-button type="primary" @click="saveServiceTerritory()">保存</el-button>
          <el-button plain @click="initServiceTerritory">取消</el-button>
        </div>
      </el-drawer>
      <el-drawer
        custom-class="c-drawer"
        title="编辑服务区域"
        :visible.sync="serviceTerritory.openEdit"
        direction="rtl"
        @close="initServiceTerritory"
      >
        <div class="el-drawer__content">
          <el-form
            :model="serviceTerritory.formData"
            :rules="rules"
            ref="serviceTerritoryFormData"
            label-width="120px"
            label-position="left"
            hide-required-asterisk:true
          >
            <el-form-item label="服务区域名称" prop="name">
              <el-input
                v-model="serviceTerritory.formData.name"
                placeholder="请输入服务区域名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="国家" prop="country">
              <el-input
                v-model="serviceTerritory.formData.country"
                placeholder="请输入国家"
              ></el-input>
            </el-form-item>
            <el-form-item label="省市区" v-if="serviceTerritory.openEdit">
              <el-cascader
                :options="area.options"
                :props="area.props"
                v-model="serviceTerritory.formData.area"
                collapse-tags
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="街道" prop="street">
              <el-input
                v-model="serviceTerritory.formData.street"
                placeholder="请输入街道"
              ></el-input>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input
                v-model="serviceTerritory.formData.address"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮编" prop="postalCode">
              <el-input
                v-model="serviceTerritory.formData.postalCode"
                placeholder="请输入邮编"
              ></el-input>
            </el-form-item>
            <el-form-item label="描述" prop="description">
              <el-input
                v-model="serviceTerritory.formData.description"
                placeholder="请输入描述"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="el-drawer__footer">
          <el-button type="primary" @click="saveServiceTerritory()">保存</el-button>
          <el-button plain @click="initServiceTerritory()">取消</el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
// import areajs from '../../resources/js/area.js';
export default {
  name: 'serviceResource',
  components: {
    bizStackTrace: () => import('../../components/bizStackTrace')
  },
  data() {
    window.$this = this;
    return {
      tenantId: '',
      dataAuth: '',
      dataAuthId: '', //当前登陆人的角色id
      id: null,
      collapse: false,
      formData: {
        relatedRecordId: '',
        serviceCrewId: '',
        parameter: [],
        exts: {},
        gpsPoint: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      fieldsObj: {},
      options: {
        codecfg_resourceType: { codeId: 'resourceType' },
        codecfg_resourceLevel: { codeId: 'resourceLevel' },
        codecfg_resourceRoles: { codeId: 'resourceRoles' },
        codecfg_sex: { codeId: 'SEX' },
        codecfg_workState: { codeId: 'workState' },
        codecfg_serviceType: { codeId: 'serviceType' },
        resourceType: [],
        org: [],
        user: [],
        role: []
      },
      rules: this.$util.rules,
      activeTab: 'log',
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      historyFpi: {
        page: 1,
        rows: 0,
        data: [],
        busy: false
      },
      noteData: [],
      openNote: false,
      vqeditor: this.$util.vqeditor,
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: $this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址级联
      area: {
        props: {
          multiple: true
        },
        options: this.osg.areaList
      },
      relatedData: [],
      serviceTerritory: {
        relatedData: [],
        openRelate: false,
        openEdit: false,
        Date: [],
        formData: {},
        activeName: 'search'
      }
    };
  },
  mounted() {
    this.tenantId = this.osg.isJson(sessionStorage['entity'])
      ? JSON.parse(sessionStorage['entity']).tenantId
      : '';
    this.dataAuth = this.osg.isJson(sessionStorage['currentRole'])
      ? JSON.parse(sessionStorage['currentRole']).dataAuth
      : null;
    this.dataAuthId = this.osg.isJson(sessionStorage['currentRole'])
      ? JSON.parse(sessionStorage['currentRole'])._id
      : '';

    this.id = this.osg.param('id');
    this.osg.setLastRowId('ServiceAppointments', this.id);
    this.osg.getFields('serviceResource', () => {
      this.getData();
    });
    this.getLog();
    this.getNote();
    this.getRoles();
  },
  methods: {
    formatRoles(value) {
      return this.osg.codelabelForArray('roles', value);
    },
    formatSex(value) {
      return this.osg.codelabel('sex', value);
    },
    formatRole(value) {
      return this.osg.codelabelForArray('role', value);
    },
    getData() {
      this.osg.ajax(`biz/serviceResource/findById/${this.id}.do`, {}, res => {
        let row = res;
        row.exts = row.exts || {};
        row.gpsPoint = row.gpsPoint || {};
        this.$util.renderExtField(this.extFields, row);
        // 获取参数表关联数据
        if (row.resourceLevel) {
          this.getParameter(row._id, res => {
            if (res.data.length > 0) {
              row.parameter = res.data;
            } else {
              row.parameter = [
                {
                  sourceType: '1',
                  sourceTypeId: row._id,
                  keyName: '日接单数上限',
                  key: 'guanjia_S_dayCount',
                  value: ''
                },
                {
                  sourceType: '1',
                  sourceTypeId: row._id,
                  keyName: '月接单数上限',
                  key: 'guanjia_S_monthCount',
                  value: ''
                }
              ];
            }
            this.formData = row;
          });
        } else {
          row.parameter = [
            {
              sourceType: '1',
              sourceTypeId: row._id,
              keyName: '日接单数上限',
              key: 'guanjia_S_dayCount',
              value: ''
            },
            {
              sourceType: '1',
              sourceTypeId: row._id,
              keyName: '月接单数上限',
              key: 'guanjia_S_monthCount',
              value: ''
            }
          ];
          this.formData = row;
        }
        this.formData = row;
        if (
          this.formData.resourceType == 'serviceCrew' ||
          this.formData.resourceType == 'partner'
        ) {
          this.getOrg();
        } else {
          this.getUser();
        }
        //获取属性修改记录
        this.getHistory();
        this.getRole();
        this.getRelated();
        this.getServiceTerritoryData(null, row._id);
      });
    },
    async doSave() {
      if (this.osg.validate()) {
        if (this.formData.resourceLevel) {
          for (let param of this.formData.parameter) {
            if (
              !param.value &&
              param.value !== 0 &&
              (this.dataAuth > 3 ||
                this.dataAuth == 0 ||
                this.dataAuthId == '9144282109161981269' ||
                this.dataAuthId == '7528632979004829751')
            ) {
              debugger;
              this.osg.toast('请填写' + param.keyName, 'warning');
              return;
            }
          }
        }
        let params = this.$util.deepCopy(this.formData);
        this.$util.saveExtField(this.extFields, params);
        //保存经纬度
        params['gpsPoint.longitude'] = params.gpsPoint.longitude;
        params['gpsPoint.latitude'] = params.gpsPoint.latitude;
        delete params.gpsPoint;
        let parameter = this.$util.deepCopy(params.parameter);
        delete params.parameter;
        // 保存服务资源
        this.osg.ajax('biz/serviceResource/upsert.do', params, async () => {
          if (
            params.resourceLevel &&
            (this.tenantId == '1340835581184723420'
              ? params.resourceRoles && params.resourceRoles.indexOf('1') != -1
                ? true
                : false
              : true)
          ) {
            if (
              this.dataAuth > 3 ||
              this.dataAuth == 0 ||
              this.dataAuthId == '9144282109161981269' ||
              this.dataAuthId == '7528632979004829751'
            ) {
              // 保存参数表
              for (let formData of parameter) {
                await new Promise(resolve => {
                  this.osg.ajax(
                    'parameter/upsert.do',
                    formData,
                    () => {
                      resolve();
                    },
                    {
                      noload: true
                    }
                  );
                });
              }
            }
          } else {
            // 删除参数表关联数据
            for (let param of parameter) {
              if (param._id) {
                await new Promise(resolve => {
                  this.osg.ajax(
                    `parameter/remove/${param._id}.do`,
                    {},
                    () => {
                      resolve();
                    },
                    {
                      noload: true
                    }
                  );
                });
              }
            }
          }

          // 查询数据
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    getLog() {
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.id,
          smodule: 'serviceResource',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    getHistory() {
      // 其他getFields查询会更新掉表单的fieldsObj
      let fieldsObj = {};
      this.extFields.map(item => {
        if (item.showList && item.showList.indexOf('6') != -1) {
          item.label = item.nameDisp;
          item.value = item.name;
          fieldsObj[item.name] = item;
        }
      });
      this.fieldsObj = fieldsObj;
      this.osg.ajax(
        'biz/changeLog/query.do',
        {
          sid: this.id,
          page: this.historyFpi.page,
          rows: (this.historyFpi.rows += 10)
        },
        res => {
          if (res.data.length > 0) {
            // 不需要展示变更的字段名
            res.data = res.data.filter(item => {
              item.modifyList = item.modifyList.filter(obj => {
                return (
                  this.fieldsObj[obj.field] && this.fieldsObj[obj.field].showList.indexOf('6') != -1
                );
              });
              return item.modifyList.length > 0;
            });
            this.historyFpi = res;
          }
        },
        { noload: true }
      );
    },
    getServiceType() {
      let params = {
        'is:orgId|string#and': this.formData.serviceCrewId
      };
      this.osg.ajax(
        'basic/partner/query.do',
        params,
        res => {
          res.data.map(data => {
            this.$set(this.formData, 'serviceType', data.serviceType);
          });
        },
        { noload: true }
      );
    },
    formatField(row, column, cellValue) {
      return this.osg.codelabel('fields', cellValue);
    },
    formatFieldValue(row, column, cellValue) {
      if (this.options[row.field]) {
        return this.osg.codelabel(row.field, cellValue);
      } else {
        return cellValue;
      }
    },
    formatServiceType(cellValue) {
      return this.osg.codelabelForArray('serviceType', cellValue);
    },
    getNote() {
      this.osg.ajax(
        'note/query.do',
        {
          sid: this.id,
          smodule: 'serviceResource'
        },
        res => {
          this.noteData = res || [];
        },
        { noload: true }
      );
    },
    saveNote() {
      var params = {
        sid: this.id,
        smodule: 'serviceResource',
        content: this.vqeditor.content
      };
      this.osg.ajax('note/upsert.do', params, res => {
        this.openNote = false;
        this.getNote();
      });
    },
    noteMdShow(note) {
      note.openNote = true;
    },
    //修改服务资源类型
    resourceTypeChange() {
      this.formData.relatedRecordId = '';
      this.formData.serviceCrewId = '';
      if (this.formData.resourceType == 'serviceCrew' || this.formData.resourceType == 'partner') {
        this.getOrg();
      } else {
        this.getUser();
        //服务资源是user时，位置信息置空通过定位来更新。
        this.formData.gpsPoint = {};
        this.formData.lastKnownLocation = '';
        this.formData.lastKnownLocationDate = '';
      }
    },
    /*//选择服务资源
    relatedChange(id) {
      if (id) {
        if (
          this.formData.resourceType == "serviceCrew" ||
          this.formData.resourceType == "partner"
        ) {
          let org = this.options.org.find(item => {
            return item._id == id;
          });
          this.formData.relatedName = org.label;
        } else {
          let user = this.options.user.find(item => {
            return item._id == id;
          });
          this.formData.relatedName = user.label;
        }
      } else {
        this.formData.relatedName = "";
      }
      this.$forceUpdate();
    },*/
    //获取组织
    getOrg(query) {
      this.osg.ajax(
        'org/query.do',
        {
          orgType: this.formData.resourceType,
          'regex:orgName|string#and': query,
          'exists:serviceResourceId|boolean#or': false,
          'is:serviceResourceId|string#or': this.formData._id
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.org = res.data.orgList;
          this.osg.ajax(
            'org/query.do',
            {
              notFilterOrgId: '1', //解决合伙人内勤查不到当前组织 无法返显的问题
              'is:serviceResourceId|string#or': this.formData._id
            },
            res => {
              res.data.orgList.map(item => {
                item.label = item.orgName;
                item.value = item._id;
              });
              this.options.org = this.options.org.concat(res.data.orgList);
            },
            { noload: true }
          );
        },
        { noload: true }
      );
    },
    //获取用户
    getUser(query) {
      let params = {
        _all: '1',
        tenantId: this.tenantId,
        'regex:name|string#and': query,
        'exists:serviceResourceId|boolean#or': false,
        'is:serviceResourceId|string#or': this.formData._id
      };
      this.osg.ajax(
        'user/query.do',
        params,
        res => {
          let arr = [];
          res.data.map(item => {
            // 不展示超级管理员
            if (item._id != item.tenantId) {
              item.label = item.name;
              item.value = item._id;
              arr.push(item);
            }
          });
          this.options.user = arr;
        },
        { noload: true }
      );
    },
    //获取角色
    getRole() {
      this.osg.ajax('role/query.do', { _all: '1' }, res => {
        res.data.map(
          item => {
            item.label = item.name;
            item.value = item._id;
          },
          { noload: true }
        );
        this.options.role = res.data;
      });
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.lastKnownLocation) {
        this.osg.geocode(this.formData.lastKnownLocation, res => {
          this.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.formData.lastKnownLocationDate = new Date()
            .toLocaleString('chinese', {
              hour12: false
            })
            .replace(/\//g, '-');
          this.$forceUpdate();
        });
      }
    },
    //获取关联信息
    getRelated() {
      if (!this.formData.relatedRecordId && !this.formData.serviceCrewId) return;
      if (this.formData.resourceType == 'serviceCrew') {
        this.osg.ajax(
          'org/query.do',
          { 'is:_id|string#and': this.formData.serviceCrewId },
          res => {
            this.relatedData = res.data.orgList;
          },
          { noload: true }
        );
      } else if (this.formData.resourceType == 'partner') {
        this.osg.ajax(
          'basic/partner/query.do',
          { 'is:orgId|string#and': this.formData.serviceCrewId },
          res => {
            this.relatedData = res.data;
          },
          { noload: true }
        );
      } else {
        this.osg.ajax(
          'user/query.do',
          { 'is:_id|string#or': this.formData.relatedRecordId },
          res => {
            this.relatedData = res.data;
          },
          { noload: true }
        );
      }
    },
    // 关联服务区域
    initServiceTerritory() {
      this.serviceTerritory.searchObj = {};
      this.serviceTerritory.openEdit = false;
      this.serviceTerritory.openRelate = false;
      this.serviceTerritory.formData = {};
      this.serviceTerritory.activeName = 'search';
      this.$refs['serviceTerritoryFormData'].resetFields();
    },
    newServiceTerritory() {
      this.getServiceTerritoryData();
      this.serviceTerritory.openRelate = true;
    },
    editServiceTerritory(item) {
      item = this.$util.deepCopy(item);
      item.gpsPoint = item.gpsPoint || {};
      if (item.area) item.area = JSON.parse(item.area);
      this.serviceTerritory.formData = item;
      this.serviceTerritory.openEdit = true;
    },
    getServiceTerritoryData(query, serviceResourceId) {
      var params = {
        page: 1,
        rows: 100,
        'all:relatedIds|string#and': serviceResourceId,
        'regex:name|string#or': query
      };
      //搜索关联（全部工单），不返回已关联的工单
      if (!serviceResourceId) {
        params['nin:relatedIds|string#and'] = this.id;
      }
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        params,
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          if (serviceResourceId) {
            this.serviceTerritory.relatedData = res.data;
          } else {
            this.serviceTerritory.data = res.data;
          }
          this.$forceUpdate();
        },
        { noload: true }
      );
    },
    saveServiceTerritory(type) {
      //搜索关联
      if (type == 'search') {
        this.serviceTerritory.searchObj.relatedIds =
          this.serviceTerritory.searchObj.relatedIds || [];
        this.serviceTerritory.searchObj.relatedIds.push(this.id);
        let obj = this.serviceTerritory.searchObj;

        //省市区支持多选
        // obj.area = obj.area || [];
        // let province = [];
        // let city = [];
        // let district = [];
        // for (let item of obj.area) {
        //   if (province.indexOf(item[0]) == -1) province.push(item[0]);
        //   if (city.indexOf(item[1]) == -1) city.push(item[1]);
        //   if (district.indexOf(item[2]) == -1) district.push(item[2]);
        // }
        // obj.province = province;
        // obj.city = city;
        // obj.district = district;
        // obj.area = JSON.stringify(obj.area);

        // obj.area = obj.area || [];
        // if (obj.area.length > 0) {
        //   obj.province = obj.area[0] || "";
        //   if (obj.area.length > 1) {
        //     obj.city = obj.area[1] || "";
        //     if (obj.area.length > 2) {
        //       obj.district = obj.area[2] || "";
        //     }
        //   }
        // }
        // delete obj.area;
        //保存经纬度
        obj.gpsPoint = obj.gpsPoint || {};
        obj['gpsPoint.longitude'] = obj.gpsPoint.longitude;
        obj['gpsPoint.latitude'] = obj.gpsPoint.latitude;
        delete obj.gpsPoint;
        this.osg.ajax(
          'basic/serviceTerritory/upsert.do',
          obj,
          () => {
            this.getData();
          },
          { noload: true }
        );
        this.initServiceTerritory();
      } else {
        this.serviceTerritory.formData.relatedIds = this.serviceTerritory.formData.relatedIds || [];
        if (this.serviceTerritory.formData.relatedIds.indexOf(this.id) == -1) {
          //新建 将新服务资源id保存到服务区域relatedIds字段
          this.serviceTerritory.formData.relatedIds.push(this.id);
        } // else即编辑
        var obj = this.serviceTerritory.formData;
        //省市区支持多选
        obj.area = obj.area || [];
        let province = [];
        let city = [];
        let district = [];
        for (let item of obj.area) {
          if (province.indexOf(item[0]) == -1) province.push(item[0]);
          if (city.indexOf(item[1]) == -1) city.push(item[1]);
          if (district.indexOf(item[2]) == -1) district.push(item[2]);
        }
        obj.province = province;
        obj.city = city;
        obj.district = district;
        obj.area = JSON.stringify(obj.area);
        delete obj.label;
        delete obj.value;
        //保存经纬度
        obj.gpsPoint = obj.gpsPoint || {};
        obj['gpsPoint.longitude'] = obj.gpsPoint.longitude;
        obj['gpsPoint.latitude'] = obj.gpsPoint.latitude;
        delete obj.gpsPoint;
        if (this.osg.validate('serviceTerritoryFormData')) {
          this.osg.ajax(
            'basic/serviceTerritory/upsert.do',
            this.serviceTerritory.formData,
            () => {
              this.getData();
              this.initServiceTerritory();
            },
            { noload: true }
          );
        }
      }
    },
    removeServiceTerritory(item) {
      this.osg.confirm(`删除与 "${item.name}" 的关联？`, () => {
        var relatedIds = item.relatedIds;
        for (let i = 0; i < relatedIds.length; i++) {
          if (this.id == relatedIds[i]) {
            relatedIds.splice(i, 1);
            //更新服务区域relatedIds字段，删除当前服务资源_id
            this.osg.ajax(
              'basic/serviceTerritory/upsert.do',
              item,
              res => {
                this.getServiceTerritoryData(null, this.id);
              },
              { noload: true }
            );
            return;
          }
        }
      });
    },
    // 获取角色
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        {
          _all: '1'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.roles = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 修改资源等级动态修改参数表关联数据
    resourceLevelChange() {
      if (this.formData.resourceLevel) {
        for (let param of this.formData.parameter) {
          if (param.key) {
            let arr = param.key.split('_');
            param.key = this.formData.resourceLevel + '_' + arr[arr.length - 1];
          }
        }
      }
    },
    getParameter(sId, callback) {
      this.osg.ajax(
        'parameter/query.do',
        {
          sourceTypeId: sId,
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'key',
          sortOrder: 'asc'
        },
        res => {
          if (callback) callback(res);
        }
      );
    }
  },
  watch: {
    'serviceTerritory.activeName'() {
      this.serviceTerritory.searchObj = {};
    }
  }
};
</script>
